exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".npo-charityTitle___18sjn {\n  margin-bottom: 20px;\n}\n", "", {"version":3,"sources":["/causefundraisernodeweb-ci-1233/workspace/causefundraisernodeweb-ci-1233/public/js/components/benefits/benefits.less"],"names":[],"mappings":"AAAA;EACE,oBAAoB;CACrB","file":"benefits.less","sourcesContent":[".npo-charityTitle {\n  margin-bottom: 20px;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"npo-charityTitle": "npo-charityTitle___18sjn"
};